<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form  :inline="true" :model="searchForm" ref="searchForm" label-width="110px" size="mini">
          <el-form-item label="短信编码" prop="templateId">
            <el-input class="form-input" v-model="searchForm.templateId" clearable></el-input>
          </el-form-item>
          <el-form-item label="发送人" prop="smsTheme">
            <el-input class="form-input" v-model="searchForm.smsTheme" clearable></el-input>
          </el-form-item>
          <el-form-item label="发送类型" prop="sendType">
            <el-select v-model="searchForm.sendType" clearable @change="onSearch">
              <el-option v-for="item in sendType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="接收手机号" prop="phone">
            <el-input class="form-input" v-model="searchForm.phone" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属经销商编码" prop="customerCode">
            <el-input class="form-input" v-model="searchForm.customerCode" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属经销商名称" prop="customerName">
            <el-input class="form-input" v-model="searchForm.customerName" clearable></el-input>
          </el-form-item>
          <el-form-item label="发送结果" prop="sendStatus">
            <el-select v-model="searchForm.sendStatus" clearable @change="onSearch">
              <el-option v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送时间">
            <q-date-picker startFiled="sendDateStart" endFiled="sendDateEnd" v-model="searchForm" ref="dateRef" />
          </el-form-item>
        
        </el-form>
        <template v-slot:right>
          <el-button size="small" type="primary" @click="onSearch">查询</el-button>
          <el-button size="small" @click="resetSearchForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="exportList">导出</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        border
        highlight-current-row
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="templateId" label="短信编码" align="center" show-overflow-tooltip min-width="160"></el-table-column>
        <el-table-column prop="content" label="短信内容" show-overflow-tooltip min-width="260"></el-table-column>
        <el-table-column prop="smsTheme" label="发送人" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="sendType" label="发送类型" show-overflow-tooltip  align="center"></el-table-column>
        <el-table-column prop="phone" label="接收手机号" align="center" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="customerCode" label="所属经销商编码" align="center" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="customerName" label="所属经销商名称" align="center" show-overflow-tooltip min-width="120"></el-table-column>
        <el-table-column prop="splitSmsCount" label="拆分数" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sendDate" label="发送时间" align="center" show-overflow-tooltip min-width="160"></el-table-column>
        <el-table-column prop="sendStatus" label="发送结果" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column  label="操作" width="160"  class-name="action-column" fixed="right" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="checkDetail(scope.row)">查看详情</el-button>
            <!-- <el-button type="text" size="small" @click="checkPhone(scope.row)">查看手机号</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right;">
          <el-pagination
            @size-change="onSizeChange"
            @current-change="onNumChange"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            :page-sizes="[20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </template>
    </table-panel>
    <check-phone :isCheckPhone.sync="isCheckPhone" :phone="phone"/>
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import checkPhone from './cheack-phone'
export default {
  name: "smsList",
  mixins: [tableMixin,pagePathMixin],
  components: {
    checkPhone
  },
  data() {
    return {
      searchForm: {
        templateId: '',
        smsTheme: '',
        sendType: '',
        phone: '',
        customerCode: '',
        customerName: '',
        sendStatus: '',
        sendDateStart: "",
        sendDateEnd: "",
        dataType: ''
      },
      // 表格相关
      tableData: [],
      selection: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {},
      loading: false,
      resizeOffset: 70,
      statusOptions: [
        {value: '', label: '全部'},
        {value: '成功', label: '成功'},
        {value: '失败', label: '失败'}
      ],
      sendType: [
        {value: '', label: '全部'},
        {value: '人工发送', label: '人工发送'},
        {value: '系统发送', label: '系统发送'}
      ],
      isCheckPhone: false,
      phone: ''
    }
  },
 
  methods: {
    init() {
      this.onSearch();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        }
      }
      this.$api.dataReport.querySmsSendList(params)
        .then(({data: {list, total}}) => {
          this.tableData = list || [];
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    handleSelectionChange(selection) {
      this.selection = selection;
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.initDate()
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {
        createUserId: this.$route.query.userId || ''
      };
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (typeof val !== 'undefined' && val !== null && val !== '') {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    checkDetail(row) {
      const { content,sendDate,phone,phoneRsa} = row
      this.openSubPage({
        path: 'smsDetail',
        query: {content,sendDate,phone,phoneRsa,smsType: '通知'}
      })
    },
    checkPhone(row) {
      this.$api.dataReport.decodePhone({phoneRsa:row.phoneRsa})
        .then(res => {
          this.phone = res.data
          this.isCheckPhone = true
        })
    },
    initDate() {
      this.searchForm.sendDateStart = ''
      this.searchForm.sendDateEnd = ''
      this.$refs.dateRef.reset()
    },
    exportList() {
      let params = {
        ...this.filterParam,
      };
      this.$api.common.doExport("querySmsSendList", params).then(() => {
        this.$message.success("导出操作成功，请前往导出记录查看详情");
      });
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
.content 
  width 100%
  height 100%
  display flex
  justify-content center
  align-items center
  flex-direction column
  .or-code 
    width 140px
    height 140px
    margin-top 20px
</style>